import pubsub from 'pubsub-js';
import gaTracker from './ga-tracker';
import productData from './product-data';

let $calculator = $('.js-calculator'),
	$calcRadioButtons = $calculator.find('[type=radio]'),
	$calcMonthBreakdown = $calculator.find('.js-calc-monthly-price'),
	$calcTotalPrice = $calculator.find('.js-calc-total-price'),
	$calcAddToCart = $calculator.find('.js-calc-add-to-cart');

let cachedDurationValue = '3', // Default is 3MO 
	cachedPlanValue = '2'; // Default is 2GB

function calculatePrice(e, data) {
	
	var monthlyPrice = productData.price[data.plan]['monthly'][data.duration],
		totalPrice = productData.price[data.plan]['total'][data.duration],
		url = productData.url[data.plan][data.duration],
		sku = productData.sku[data.plan][data.duration],
		ecommTracker = 'click|' + sku + '|' + sku + '|' + totalPrice + '|Mint Mobile|Plans|1';

	data.$calcMonthBreakdown.html(monthlyPrice);
	data.$calcTotalPrice.html(totalPrice);
	
	if (data.duration == '3') {
		$('.js-special-rate').show();
		$('.js-default-rate').hide();
	} else {
		$('.js-special-rate').hide();
		$('.js-default-rate').show();
	}
	
	$('.js-plan-details-link')
		.attr('href', url)
		.attr('data-ecomm', ecommTracker);
}

function handleCalcEvent(e, data) {

	if (data.id === 'duration') {
		cachedDurationValue = productData.value[data.id][data.value];
	} else {
		cachedPlanValue = productData.value[data.id][data.value];
	}

	pubsub.publish('calc.calculate', {
		duration: cachedDurationValue,
		plan: cachedPlanValue,
		$calcMonthBreakdown,
		$calcTotalPrice
	});

}

function init() {
	let $calcMonthBreakdownWrapper = $calculator.find('.js-calc-monthly-price-wrapper'),
		$calcTotalPriceWrapper = $calculator.find('.js-calc-total-price-wrapper'),
		$calcBreakdownBtn = $calculator.find('.js-calc-breakdown-btn'),
		$calcTotalPriceBtn = $calculator.find('.js-calc-total-btn');
	
	$calcBreakdownBtn.on('click', function() {
		$calcMonthBreakdownWrapper.show();
		$calcTotalPriceWrapper.hide();
		$calcTotalPriceBtn.removeClass('active');
		$(this).addClass('active');
		
		// gaTracker.track('Calculator Break Down|' + cachedDurationValue + 'mo' + cachedPlanValue + 'gb');
	});

	$calcTotalPriceBtn.on('click', function() {
		$calcMonthBreakdownWrapper.hide();
		$calcTotalPriceWrapper.show();
		$calcBreakdownBtn.removeClass('active');
		$(this).addClass('active');
		
		// gaTracker.track('Calculator Total Price|' + cachedDurationValue + 'mo' + cachedPlanValue + 'gb');
	});

	$calcAddToCart.on('click', function() {
		
		var totalPrice = productData.price[cachedPlanValue]['total'][cachedDurationValue],
			id = productData.id[cachedPlanValue][cachedDurationValue],
			sku = productData.sku[cachedPlanValue][cachedDurationValue],
			ecommTracker = 'add|' + sku + '|' + sku + '|' + totalPrice + '|Mint Mobile|Plans|1';
			
		// Pass in the product ID as well as the assumed quantity of "1" from the homepage.
		pubsub.publish('cart.add_item', {
			type: 'plan',
			quantity: 1,
			price: totalPrice,
			id: id,
			tracker: ecommTracker
		});

		// GA tracking. ex) 'Calculagtor|6mo10gb' - Location|Value
		// gaTracker.track('Calculator|' + cachedDurationValue + 'mo' + cachedPlanValue + 'gb');
	});

	pubsub.subscribe('slider.change', handleCalcEvent);

	pubsub.subscribe('calc.calculate', calculatePrice);

}

export default init;
